/**Takes an array of values or objects, plus an optional value selector, and returns
 * the min value (ignoring zero or null).
 *
 * (works very similar to d3.min but doesn't upset Typescript and ignores zero values).
 *
 * @param values
 * @param valueOf
 * @returns(number)
 */
export const getMin = (
  values: any[],
  valueOf: (value: any) => number
): number => {
  return values.reduce((min, rootValue) => {
    const value =
      typeof valueOf === "function" ? valueOf(rootValue) : rootValue;
    if (isNaN(value) || value === 0) {
      return min;
    }
    return Math.min(min, value);
  }, Number.MAX_SAFE_INTEGER);
};

/**Takes an array of values or objects, plus an optional value selector, and returns
 * the max value (ignoring zero or null).
 *
 * (works very similar to d3.min but doesn't upset Typescript and ignores zero values).
 *
 * @param values
 * @param valueOf
 * @returns(number)
 */
export const getMax = (
  values: any[],
  valueOf: (value: any) => number
): number => {
  return values.reduce((max, rootValue) => {
    const value =
      typeof valueOf === "function" ? valueOf(rootValue) : rootValue;
    if (isNaN(value) || value === 0) {
      return max;
    }
    return Math.max(max, value);
  }, 0);
};

export const generateUuid = (
  format = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
) => {
  let date = new Date().getTime();
  const uuid = format.replace(/[xy]/g, function(character) {
    const r = (date + Math.random() * 16) % 16 | 0;
    date = Math.floor(date / 16);
    return (character === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};
